import { CancelToken } from 'axios';
import config from 'config';
import axiosInstance from '../API/createAxisInstance';
import { downloadTapsFile } from '../TAPS_ATTACH_API';
import { getStore } from 'configureStore';
import { routeMap } from 'router';
import { get } from 'lodash';
import { push } from 'redux-little-router';

export default class API {
  static baseUrl = config.tapsApiBaseUrl;

  /**
   * @param {'GET'|'PUT'|'POST'|'DELETE'} method
   * @param {string} url
   * @param {object} [params]
   * @param {object} [data]
   * @param {object} [headers]
   * @param {function} [mapper]
   * @param {boolean} [cancelable]
   * @returns {AxiosPromise|object}
   */
  static request(
    { method, url, params, data, headers, mapper = (data) => data, responseType },
    cancelable,
  ) {
    let cancel = null;
    const request = axiosInstance({
      method,
      url: `${API.baseUrl}${url}`,
      params,
      data,
      headers,
      responseType,
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    }).then((response) => {
      if (response.isOk) {
        return { ...response, data: mapper(response.data) };
      } else {
        if (get(response, 'error.response.data.errorType') === 'isDemo') {
          getStore().dispatch(
            push({
              pathname: routeMap.error,
              query: {
                title: 'Функционал недоступен',
                message:
                  'В демонстрационном режиме данный функционал недоступен. Для его использования Вы можете авторизоваться в полной версии личного кабинета ФЛ.',
                backPage: window.location,
              },
            }),
          );
        }
        return response;
      }
    });

    return cancelable ? { cancel, request } : request;
  }
}

/**
 * Download pdf from messages page
 * @param {string} pdf
 * @param {string} inn
 * @param {string} attachmentId
 * @param {string} attachmentType
 * @param {Object} cancelObj
 * @returns {Promise}
 */
export function downloadPdfWithAttachmentTypes(
  pdf,
  inn,
  attachmentId,
  attachmentType,
  notificationId,
  cancelObj = {},
) {
  return axiosInstance({
    method: 'GET',
    url: `${config.tapsApiBaseUrl}/attach/download/prepare/${inn}`,
    params: {
      filename: pdf,
      attachmentType,
      attachmentId,
      notificationId,
    },
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      cancelObj[pdf] = c;
    }),
  });
}

export function downloadPdfService(pdf, inn, cancelObj = {}) {
  return axiosInstance({
    method: 'GET',
    url: encodeURI(`${config.tapsApiBaseUrl}/attach/download/prepare/${inn}?filename=${pdf}`),
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    cancelToken: new CancelToken(function executor(c) {
      // An executor function receives a cancel function as a parameter
      cancelObj[pdf] = c;
    }),
  });
}

export function tapsUploadService(serverFileName, inn) {
  return API.request({
    method: 'GET',
    url: encodeURI(`/attach/upload/done/${inn}?filename=${serverFileName}`),
  });
}

export async function getPdfByteArrayService(fileName, inn) {
  const prepareResponse = await downloadPdfService(fileName, inn);

  if (!prepareResponse.isOk) {
    throw prepareResponse.error;
  }

  const fileResponse = await downloadTapsFile(fileName, inn);

  if (!fileResponse.isOk) {
    throw fileResponse.error;
  }

  return fileResponse.data;
}

export function validateRegionName(regionName) {
  return API.request({
    method: 'POST',
    url: `/kladr/validate`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    data: { regionName },
  });
}

/**
 * Returns list of available declaration years for selected filling mode
 * @param {number} mode - Declaration filling mode
 * @returns {AxiosPromise|Object}
 */
export function availableYearsService(mode) {
  return API.request({
    method: 'GET',
    url: `/notification/1151020/years`,
    params: { mode },
  });
}
